// contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useMemo  } from 'react';
import PropTypes from 'prop-types'

import {
  isUserAuthenticated,
  getUserInfo, 
  storeAuthDetails, 
} from '../utils/authUtil';

const AuthContext = createContext();
const MARKETPLACE_STORAGE_PREFIX = 'marketplace_';

const clearStorageExceptMarketplace = () => {
  const marketplaceEntries = {};

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);

    if (key && key.startsWith(MARKETPLACE_STORAGE_PREFIX)) {
      marketplaceEntries[key] = localStorage.getItem(key);
    }
  }

  localStorage.clear();

  Object.entries(marketplaceEntries).forEach(([key, value]) => {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  });
};

export function AuthProvider({ children }) {
  const activeSession = isUserAuthenticated();
  const [isAuthenticated, setIsAuthenticated] = useState(activeSession);
  const [userInfo, setUserInfo] = useState(getUserInfo());

  useEffect(() => {
    setIsAuthenticated(activeSession);
    if (!activeSession){
      logout(); // clear localstorage
    }
  }, [activeSession]);

  const login =(authDetails) => {
    storeAuthDetails(authDetails.user_info?.access_token || authDetails);
    const activeSession = isUserAuthenticated();
    setIsAuthenticated(activeSession);
    setUserInfo(getUserInfo());
    localStorage.setItem('isAuthenticated', activeSession);
  };

  const logout = () => {
    clearStorageExceptMarketplace();
    setIsAuthenticated(false);
    setUserInfo(null);
  };


  const contextValue = useMemo(
    () => ({
      isAuthenticated,
      userInfo,
      login,
      logout,
    }),
    [userInfo, isAuthenticated]
  );

  return (
    <AuthContext.Provider value= {contextValue}>
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.element.isRequired,
}

export function useAuth() {
  const context =  useContext(AuthContext);
  if (!context) {
    const message = "AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component."
    console.error(message);
    throw new Error(message);
  }

  return context;

}
